class ReasonType {
    static NEW = 1;
    static EXTEND  = 2;
  }
  
  export default ReasonType;
  